'use client';

import { create } from 'zustand';

interface ClaimSheetState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

/**
 * Drives the single app-level achievement claim sheet (mounted via
 * `AchievementClaimSheet`). Opened from the achievements banner and from
 * unclaimed achievement cards.
 */
export const useClaimSheetStore = create<ClaimSheetState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));

export const useOpenClaimSheet = () => useClaimSheetStore((s) => s.open);
